import React, { useEffect, useState } from 'react';
import searching from '@/assets/houseupper.jpg';
import './newLanding.css';
import { useNavigate } from 'react-router-dom';
import { SearchCategory } from './SearchTabContent/SearchCategory';
import mouseIcon from '@/assets/mouseIcon.png';
import roundedBg from '@/assets/roundedBg.png';
import shape from '@/assets/s-right.png';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import gpay from '@/assets/g-pay.png';
import astore from '@/assets/a-store.png';
import { SearchTabForm } from './SearchTabContent/SearchTabForm';
import Slider from 'react-slick';
import { useCountryList, useTopCountryList } from '@/api/landing/landingPage';
import { Button } from '@/components/Elements';
import { upperFirst } from 'lodash';

export const SearchTabs = ({ setApply, setFilterData, refetch }: any) => {
  const [activeCategory, setActiveCategory] = useState(''); // Default category
  const [searchVal, setSearchVal] = useState('');
  const navigate = useNavigate();
  const { data: country } = useCountryList();
  const { data: topCountry } = useTopCountryList();

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };
  const settings = {
    className: 'slider variable-width',
    dots: true,
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    // responsive: [
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 480,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //     },
    //   },
    // ],
  };

  const handleSearchChange = (e) => {
    setSearchVal(e.target.value);
  };

  const handleLocationChange = (e) => {
    setFilterData((prevState) => ({
      ...prevState,
      country: e.target.value,
    }));
  };

  const handleMinPriceChange = (e) => {
    setFilterData((prevState) => ({
      ...prevState,
      min_price: e.target.value,
    }));
  };

  const handleMaxPriceChange = (e) => {
    setFilterData((prevState) => ({
      ...prevState,
      max_price: e.target.value,
    }));
  };

  const handleGoToBrowse = () => {
    document.getElementById('viewProperty')?.scrollIntoView({
      behavior: 'smooth',
    });
  };
  return (
    <section className="new-search relative text-white ">
      <div className="w-100">
        <div
          className="search-content-bg rounded "
          style={{ backgroundImage: 'url(' + searching + ')' }}
        >
          {/* old hero section */}
          <div className="container d-none">
            <div className="row justify-content-between">
              <div className="content-wrapper col-md-6 pt-5">
                <span className="ticker-label"></span>
                <button className="wlcm-text border-0">Welcome to the Reeipo</button>
                <h3 className="f-30 bold text-white mt-5">
                  Discover REEIPO
                  {/* Unlock Lucrative Real Estate Investments with Us */}
                </h3>
                <p className="f-14">
                  {/* Where properties, projects and real estate opportunities meet connections
                  determined to see them succeed in today's dynamic markets. */}
                  Where properties, projects, and real estate opportunities meet connections who
                  want to see them succeed in today's hot markets.
                </p>
                <a href="#" onClick={handleGoToBrowse} className="link mt-4 d-block">
                  Start Explore
                </a>
              </div>
              <div className="top-searching-tabs pt-4 col-md-5 mb-4">
                <div className="inner-width-wrapper  slider-search pb-0">
                  <p className="heading-wrapper">Use Quick Search</p>

                  <Slider {...settings}>
                    {/* <ul
                      className="nav nav-tabs justify-content-center border-0 gap-2"
                      id="myTab"
                      role="tablist"
                    > */}
                    <button
                      className={`nav-link ${activeCategory === 'HouseRent' ? 'active' : ''}`}
                      onClick={() => handleCategoryClick('HouseRent')}
                      type="button"
                      role="tab"
                      aria-selected={activeCategory === 'HouseRent'}
                    >
                      House Rent
                    </button>
                    <button
                      className={`nav-link ${activeCategory === 'BussinessSale' ? 'active' : ''}`}
                      onClick={() => handleCategoryClick('BussinessSale')}
                      type="button"
                      role="tab"
                      aria-selected={activeCategory === 'BussinessSale'}
                    >
                      Bussiness Sale
                    </button>
                    <button
                      className={`nav-link ${activeCategory === 'PropertyProject' ? 'active' : ''}`}
                      onClick={() => handleCategoryClick('PropertyProject')}
                      type="button"
                      role="tab"
                      aria-selected={activeCategory === 'PropertyProject'}
                    >
                      Property Project
                    </button>
                    <button
                      className={`nav-link ${activeCategory === 'RentProperty' ? 'active' : ''}`}
                      onClick={() => handleCategoryClick('RentProperty')}
                      type="button"
                      role="tab"
                      aria-selected={activeCategory === 'RentProperty'}
                    >
                      Rent Property
                    </button>
                    {/* <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeCategory === 'InvestmentCompany' ? 'active' : ''
                          }`}
                        onClick={() => handleCategoryClick('InvestmentCompany')}
                        type="button"
                        role="tab"
                        aria-selected={activeCategory === 'InvestmentCompany'}
                      >
                        Investment Company
                      </button>
                    </li> */}
                    <button
                      className={`nav-link ${activeCategory === 'SaleProperty' ? 'active' : ''}`}
                      onClick={() => handleCategoryClick('SaleProperty')}
                      type="button"
                      role="tab"
                      aria-selected={activeCategory === 'SaleProperty'}
                    >
                      Sale Property
                    </button>

                    <button
                      className={`nav-link ${activeCategory === 'companySeeking' ? 'active' : ''}`}
                      onClick={() => handleCategoryClick('companySeeking')}
                      type="button"
                      role="tab"
                      aria-selected={activeCategory === 'companySeeking'}
                    >
                      Company Seeking
                    </button>

                    <button
                      className={`nav-link ${
                        activeCategory === 'property_developers' ? 'active' : ''
                      }`}
                      onClick={() => handleCategoryClick('property_developers')}
                      type="button"
                      role="tab"
                      aria-selected={activeCategory === 'property_developers'}
                    >
                      Property Developer
                    </button>
                    {/* </ul> */}
                  </Slider>
                  <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade show active">
                      <SearchCategory category={activeCategory} setApply={setApply} />
                      {/* <SearchTabForm category={activeCategory} setApply={setApply} /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container new-hero-section relative z-1">
            <div className="row justify-content-between ">
              <div className="col-12">
                <div className="hero-section text-center">
                  <button className="wlcm-text border-0 text-white">No Deal? No Pay</button>
                  <h3 className="f-40 bold text-white ">
                    You owe us nothing until your first successful investment.
                    {/* Unlock Lucrative Real Estate Investments with Us */}
                  </h3>
                  <form>
                    <div className="search-filter d-flex align-items-center">
                      <div className="location py-1 d-flex w-50 align-items-center">
                        <span className="menu-icon ps-2">
                          <LocationOnOutlinedIcon />
                        </span>
                        <select
                          onChange={handleLocationChange}
                          className="form-select"
                          aria-label="Default select example"
                        >
                          <option selected>All Countries</option>
                          {country?.map((item, index) => {
                            return (
                              <option value={upperFirst(item)} key={index}>
                                {upperFirst(item)}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {/* <div className="types py-1 w-25">
                        <select className="form-select" aria-label="Default select example">
                          <option selected>Choose Type</option>
                          <option value="1">Villa</option>
                          <option value="2">Island</option>
                          <option value="3">Hotels</option>
                        </select>
                      </div> */}
                      <div className="start-lmt py-1 d-flex align-items-center">
                        <p>From</p>
                        <input
                          type="number"
                          onChange={handleMinPriceChange}
                          className="form-control w-75"
                          placeholder="$5,000"
                        />
                      </div>
                      <div className="start-lmt py-1 d-flex align-items-center">
                        <p>To</p>
                        <input
                          type="number"
                          onChange={handleMaxPriceChange}
                          className="form-control w-75"
                          placeholder="$500,000"
                        />
                      </div>
                      <Button
                        className="btn btn-primary search-btn rounded-0"
                        onClick={() => refetch()}
                      >
                        search
                      </Button>
                    </div>
                  </form>

                  <div className="pt-4 d-flex tags-btns justify-content-center gap-2 align-items-center">
                    {topCountry && topCountry.length > 0 ? (
                      topCountry?.map((item: any, index: number) => (
                        <button
                          onClick={() => {
                            window.location.href = `/map-list?country=${item?.country}`;
                          }}
                          className="btn tag-btn"
                          key={index}
                        >
                          {item?.country}
                        </button>
                      ))
                    ) : (
                      <div>Loading...</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="banner-shape relative z-1"
            style={{ backgroundImage: 'url(' + shape + ')' }}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-6 ms-auto">
                  <div className="join-text mt-5">
                    {/* <h5>Join Us—Get the App Today!</h5> */}
                    <h5>No upfront fees. No hidden charges. We only get paid after you invest.</h5>
                  </div>
                  {/* <div className="g-pay d-flex align-items-center gap-3">
                    <div className="g-bg d-flex gap-2 align-items-center">
                      <div className="g-img">
                        <img src={gpay} alt="" />
                      </div>
                      <div className="g-text">
                        <p className="mb-0 fs-14">Download on the</p>
                        <h6 className="mb-0 fs-14">Google Play</h6>
                      </div>
                    </div>
                    <div className="g-bg d-flex gap-2 align-items-center">
                      <div className="g-img">
                        <img src={astore} alt="" />
                      </div>
                      <div className="g-text">
                        <p className="mb-0 fs-14">Download on the</p>
                        <h6 className="mb-0 fs-14">App Store</h6>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="scroll-bottom-btn py-3 position-relative">
            <img src={roundedBg} alt="" className="position-absolute d-block w-100 bg-img" />
            <button className="d-flex gap-3 align-items-center mx-auto">
              <img src={mouseIcon} alt="" className="d-block w-100" />
              Scroll Down To Discover
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
